import { useQuery } from '@apollo/client';
import { Bolt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkDeviceSignalAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const DeviceSignalAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ deviceSignalId: string }>();
  const deviceSignalId = parseInt(params.deviceSignalId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkDeviceSignalAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, deviceSignalId },
  });

  const deviceSignal = data?.network?.deviceSignal;

  if (loading || !deviceSignal)
    return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<Bolt />}
        titleText={deviceSignal.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['DeviceSignal']} deviceSignalId={deviceSignalId} />
      </PageContainer>
    </>
  );
};
